export const documentTypes = [
  { id: 'birth', price: 30, icon: 'Baby' },
  { id: 'marriage', price: 36, icon: 'Heart' },
  { id: 'diploma', price: 28, icon: 'GraduationCap' },
  { id: 'transcript', price: 28, icon: 'FileText' },
  { id: 'criminal', price: 28, icon: 'Shield' },
  { id: 'passport', price: 28, icon: 'BookOpen' },
  { id: 'idcard', price: 37, icon: 'CreditCard' },
  { id: 'driving', price: 28, icon: 'Car' },
  { id: 'contract', price: 40, icon: 'FileSignature' },
  { id: 'judgment', price: 37, icon: 'Gavel' },
  { id: 'power', price: 32, icon: 'PenLine' },
  { id: 'apostilleDoc', price: 30, icon: 'Stamp' },
];

export const useCaseKeys = [
  { key: 'visa', icon: 'Plane' },
  { key: 'immigration', icon: 'Globe' },
  { key: 'studies', icon: 'BookOpen' },
  { key: 'marriageAbroad', icon: 'Heart' },
  { key: 'business', icon: 'Building2' },
  { key: 'legal', icon: 'Scale' },
];

export const trustBadgeKeys = [
  { key: 'sworn', icon: 'Award' },
  { key: 'guarantee', icon: 'ShieldCheck' },
  { key: 'pricing', icon: 'BadgeDollarSign' },
  { key: 'digital', icon: 'Download' },
  { key: 'whatsapp', icon: 'MessageCircle' },
  { key: 'secure', icon: 'Lock' },
];

export const qaStepKeys = [
  { key: 'step1', icon: 'FileSearch' },
  { key: 'step2', icon: 'Languages' },
  { key: 'step3', icon: 'UserCheck' },
  { key: 'step4', icon: 'Stamp' },
  { key: 'step5', icon: 'Send' },
];

export const languagePairs = [
  { from: 'Français', to: 'Arabe', code: 'fr-ar' },
  { from: 'Arabe', to: 'Français', code: 'ar-fr' },
  { from: 'Anglais', to: 'Français', code: 'en-fr' },
  { from: 'Anglais', to: 'Arabe', code: 'en-ar' },
  { from: 'Français', to: 'Anglais', code: 'fr-en' },
  { from: 'Arabe', to: 'Anglais', code: 'ar-en' },
  { from: 'Allemand', to: 'Français', code: 'de-fr' },
  { from: 'Espagnol', to: 'Français', code: 'es-fr' },
  { from: 'Italien', to: 'Français', code: 'it-fr' },
  { from: 'Arabe', to: 'Italien', code: 'ar-it' },
  { from: 'Français', to: 'Italien', code: 'fr-it' },
  { from: 'Italien', to: 'Arabe', code: 'it-ar' },
];

export const stats = [
  { value: '500K+', key: 'words' },
  { value: '2,500+', key: 'pages' },
  { value: '1,200+', key: 'clients' },
  { value: '15+', key: 'languages' },
];

export const serviceKeys = [
  { key: 'legal', icon: 'Scale' },
  { key: 'certified', icon: 'Award' },
  { key: 'academic', icon: 'GraduationCap' },
  { key: 'medical', icon: 'Stethoscope' },
  { key: 'commercial', icon: 'Building2' },
  { key: 'apostille', icon: 'Globe' },
];

export const whyKeys = [
  { key: 'quality', icon: 'BadgeCheck' },
  { key: 'speed', icon: 'Zap' },
  { key: 'price', icon: 'Wallet' },
  { key: 'support', icon: 'Headphones' },
  { key: 'guarantee', icon: 'ShieldCheck' },
  { key: 'digital', icon: 'CloudDownload' },
];

export const deliveryPricing = [
  { pages: '1-4', standard: '4 jours', express: '2-3 jours', urgent: '24-48h' },
  { pages: '5-9', standard: '5-7 jours', express: '3-4 jours', urgent: 'Devis' },
  { pages: '10+', standard: '7-10 jours', express: '5-6 jours', urgent: 'Devis' },
];

export const ecosystemKeys = [
  { key: 'translator', icon: 'Languages' },
  { key: 'notary', icon: 'Stamp' },
  { key: 'lawyer', icon: 'Scale' },
  { key: 'bailiff', icon: 'Gavel' },
];

export const translationTypeKeys = [
  { key: 'sworn', icon: 'Award', featured: true },
  { key: 'website', icon: 'Monitor' },
  { key: 'legal', icon: 'Scale' },
  { key: 'technical', icon: 'Wrench' },
  { key: 'marketing', icon: 'Megaphone' },
  { key: 'academic', icon: 'GraduationCap' },
  { key: 'localization', icon: 'Languages' },
  { key: 'subtitling', icon: 'Film' },
];

export const reviewKeys = [
  { id: 'r1', rating: 5, color: '#1a7a7a' },
  { id: 'r2', rating: 5, color: '#c9a227' },
  { id: 'r3', rating: 5, color: '#0c1e3c' },
  { id: 'r4', rating: 5, color: '#239999' },
  { id: 'r5', rating: 4, color: '#152a4a' },
  { id: 'r6', rating: 5, color: '#1a7a7a' },
];

export const languageList = [
  'Arabic', 'French', 'English', 'German', 'Spanish',
  'Italian', 'Russian', 'Turkish', 'Portuguese', 'Chinese',
  'Japanese', 'Korean', 'Dutch', 'Polish', 'Romanian',
];

/** ISO 3166-1 alpha-3 — pays mis en avant sur la carte */
export const hubCountryCode = 'TUN';

export const coveredMapColors = {
  fill: '#1a7a7a',
  hover: '#239999',
  stroke: '#0c1e3c',
};

/** Pays couverts (langues de traduction) */
export const coveredCountryCodes = new Set([
  'TUN',
  'DZA', 'MAR', 'LBY', 'EGY', 'SDN', 'SAU', 'ARE', 'IRQ', 'JOR', 'YEM',
  'OMN', 'QAT', 'KWT', 'LBN', 'SYR', 'PSE',
  'FRA', 'BEL', 'CHE', 'LUX', 'SEN', 'CIV', 'MLI', 'BFA', 'NER', 'TCD',
  'BEN', 'TGO', 'GIN', 'COD', 'CMR', 'GAB', 'COG', 'CAF', 'DJI', 'RWA',
  'BDI', 'MDG', 'HTI',
  'ITA',
  'ESP', 'MEX', 'ARG', 'COL', 'CHL', 'PER', 'VEN', 'ECU', 'BOL', 'PRY',
  'URY', 'CRI', 'CUB', 'DOM', 'GTM', 'HND', 'NIC', 'PAN', 'SLV',
  'RUS', 'BLR', 'KAZ', 'UKR', 'KGZ', 'TJK', 'UZB', 'TKM', 'MDA', 'ARM',
  'AZE', 'GEO',
  'GBR', 'USA', 'IRL', 'AUS', 'NZL', 'CAN', 'ZAF', 'IND', 'MYS', 'PHL',
  'NGA', 'GHA', 'KEN', 'JAM', 'TZA', 'UGA', 'ZMB', 'ZWE', 'BWA', 'LSO',
  'SWZ', 'SLE', 'LBR', 'MUS', 'FJI', 'PNG', 'SLB', 'VUT', 'WSM', 'TON',
]);

export function getCountryMapColors(iso) {
  return coveredCountryCodes.has(iso) ? coveredMapColors : null;
}

export const isoToCountryKey = {
  TUN: 'tunisia', FRA: 'france', GBR: 'uk', ESP: 'spain', ITA: 'italy',
  RUS: 'russia',
  MAR: 'morocco', DZA: 'algeria', LBY: 'libya', EGY: 'egypt', ARE: 'uae', SAU: 'saudi',
  USA: 'usa', CAN: 'canada', BRA: 'brazil', AUS: 'australia', IND: 'india', CHN: 'china',
  JPN: 'japan', TUR: 'turkey', BEL: 'belgium', CHE: 'switzerland', DEU: 'germany',
  PRT: 'portugal', GRC: 'greece', COL: 'colombia', CHL: 'chile',
  ARG: 'argentina', SDN: 'sudan', ETH: 'ethiopia', KEN: 'kenya', TZA: 'tanzania',
  ZAF: 'southAfrica', SEN: 'senegal', GHA: 'ghana', NGA: 'nigeria', JOR: 'jordan',
  IRQ: 'iraq', IRN: 'iran', YEM: 'yemen', OMN: 'oman', KOR: 'southKorea',
  THA: 'thailand', VNM: 'vietnam', MYS: 'malaysia', IDN: 'indonesia', PHL: 'philippines',
  NZL: 'newZealand',
};

export const mapCountries = [
  { id: 'tunisia', key: 'tunisia', iso: 'TUN', hub: true, group: 'arabic' },
  { id: 'france', key: 'france', iso: 'FRA', group: 'french' },
  { id: 'italy', key: 'italy', iso: 'ITA', group: 'italian' },
  { id: 'spain', key: 'spain', iso: 'ESP', group: 'spanish' },
  { id: 'russia', key: 'russia', iso: 'RUS', group: 'russian' },
  { id: 'uk', key: 'uk', iso: 'GBR', group: 'english' },
];
